module.exports = __webpack_public_path__ + "63244545b29da2971d5a6ef129a11c38.svg";